<template>
	<div style="margin: 10px;" v-loading="loading">
		<el-card class="box-card">
			<el-row>
				<el-col :span="24">
					<h4 class="title">商品信息</h4>
					<el-form ref="form" :model="form" label-width="160px" :rules="rules">
						<!-- 	<el-form-item label="一级分类" prop="one">
							<el-select  v-model="form.one" placeholder="一级分类" @change="getOne" style="width: 30%;">
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listOne" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="二级分类" size="mini"   v-show="twoShow">
							<el-select v-model="form.two" placeholder="二级分类" @change="getTwo($event,'two')" style="width: 30%;"clearable>
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listTwo" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="三级分类" size="mini"  v-show="threeShow">
							<el-select v-model="form.three" placeholder="三级分类"clearable>
								<el-option :label="item.columname" :value="item.id" v-for="(item,index) in listThree" :key="item.id">{{item.columname}}</el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item label="商品名称" prop="name">
							<el-input v-model="form.name" style="width: 30%;"></el-input>
						</el-form-item>
						<div class="line"></div>
						<h4 class="title" v-show="form.inputList!=0">商品参数</h4><span class="titleTip"></span>
						<el-form-item :id="item.pid" :key="index" :prop="'inputList.'+index+'.pVal'"
							:rules="{ 	required:item.must == 0?false:true, message: item.title+'不能为空', trigger: 'blur'  }"
							v-for="(item,index) in form.inputList" :label="item.title">
							<el-input v-model="item.pVal" style="width: 30%;"></el-input>
						</el-form-item>
						<div class="line" v-show="form.inputList!=0"></div>
						<h4 class="title">列表图片</h4>
						<el-form-item prop="showPic">
							<!-- <el-input type="textarea" readonly v-model="form.showPic" style="width:30%;float: left;"></el-input> -->
							<el-upload drag list-type="picture-card" action="" multiple :limit="1"
								:on-exceed="handlePic" :before-upload="beforePic" :on-remove="removeUrl"
								:file-list="fileList" style="width: auto;float: left;">
								<i class="el-icon-picture-outline"></i>
<br />
									<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet"
								style="display: inline-block;margin-top:5px;float:left;margin-right: 10px;"
								@click.stop="dialogVisible = true" value="素材库选择">
								<div class="clear"></div>
							<span class="picTip">封面图（支持JPG、JPEG、PNG图片大小限制120K）</span>
							<!-- <el-button size="mini" type="warning" style="width: float:right;margin-left: 20px;">选择图片</el-button><span class="picTip">封面图（支持JPG、JPEG、PNG图片大小限制120K）</span> -->
						</el-form-item>
						<el-form-item label="相册图片">
							<!-- <el-input readonly v-model="form.pic" style="width:30%;float: left;"></el-input> -->
							<el-upload drag list-type="picture-card" action="" multiple :on-success="getAlbum"
								:file-list="albumList" :before-upload="beforePics" style="width: auto;float: left;">
								<i class="el-icon-picture-outline"></i>
<br />
									<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet"
								style="display: inline-block;margin-top:5px;float:left"
								@click.stop="picBook = 1,dialogVisible = true" value="素材库选择">
						</el-form-item>
						<div class="line"></div>
						<h4 class="title"></h4>
						<el-form-item label="详情">
							<editor v-model="form.detail" :isClear="isClear" @change="change"></editor>
						</el-form-item>
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容"
								v-model="form.desc">
							</el-input>
						</el-form-item>
						<el-form-item label="是否置顶">
							<el-switch v-model="form.topping" active-color="#13ce66" inactive-color="#dcdfe6">
							</el-switch>
						</el-form-item>
						<el-form-item label="状态" prop="resource">
							<el-radio-group v-model="form.resource">
								<el-radio :label="0">在线</el-radio>
								<el-radio :label="1">已下线</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item>
							<input type="button" class="submit" @click="onSubmit('form')" value="提交">
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-card>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%">
			<files @selectPic="selectPic"></files>
		</el-dialog>
	</div>
</template>

<script>
import E from "wangeditor";
	// import EditorBar from '../../../components/editor.vue'
	import Editor from '../../../components/tinymce.vue'
	import files from '../../../components/picFile.vue'
	export default {
		components: {
			Editor,
			files
		},
		data() {
			return {
				form: {
					one: '',
					two: '',
					three: '',
					desc: '',
					pic: '',
					showPic: '',
					picTwo: '',
					resource: '',
					name: '',
					topping: true,
					detail: '',
					inputList: [],
					id: '',
					params: '',
					showPicThumb: '',
					picThumb: '',

				},
				editorText:'',
				loading: false,
				listOne: [],
				listTwo: [],
				listThree: [],
				albumList: [],
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					model: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}],
					// one: [{
					// 	required: true,
					// 	message: '请选择一级分类',
					// 	trigger: 'change'
					// }],
				},
				isClear: false,
				//展示图片
				fileList: [],
				twoShow: false,
				threeShow: false,
				dialogVisible: false,
				picBook: 0
			}
		},
		created() {
			// this.getType()
			if (this.$route.query.iden == 'update') {

				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v1/goods/get',
					params: {
						uid: this.$route.query.id,
						id: this.$route.query.productId,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						var list = res.data.data
						this.form.name = list.goodsName,
							this.form.resource = list.status,
							this.form.inputList = list.goodsParamList
						this.form.topping = list.roof == 0 ? true : false,
							this.form.detail = list.content
						this.form.desc = list.brief
						this.form.pic = list.album
						this.form.picThumb = list.albumThumb
						this.form.showPic = list.images
						this.form.showPicThumb = list.imagesThumb
						this.form.id = list.id
						this.fileList.push({
							url: this.settings.apiBaseImg + list.images
						})
						this.albumList.push({
							url: this.settings.apiBaseImg + list.albumThumb
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
				this.getPara()
			} else {
				this.getPara()
				this.form.resource = 0
			}
		},
		mounted() {

		},
		methods: {

			getPara() {
				var obj = this
				obj.$http({
					method: 'get',
					url: 'api/v2/goods/param/list',
					params: {
						cid: this.$route.query.id,
						id: this.form.id,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						var list = []
						for (var i = 0; i < res.data.data.length; i++) {
							list.push({
								pid: res.data.data[i].pid,
								pVal: res.data.data[i].pVal,
								must: res.data.data[i].pMust,
								title: res.data.data[i].pName
							})

						}
						this.form.inputList = list
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this
							obj.$http({
								method: 'post',
								url: 'api/v2/goods/add',
								data: {
									cid: this.$route.query.id,
									// oneCate: this.form.one,
									// twoCate: this.form.two,
									// threeCate	: this.form.three,
									goodsName: this.form.name,
									status: this.form.resource,
									goodsParamList: this.form.inputList,
									roof: this.form.topping == true ? 0 : 1,
									content: this.form.detail,
									brief: this.form.desc,
									images: this.form.showPic,
									imagesThumb: this.form.showPicThumb,
									album: this.form.pic,
									albumThumb: this.form.picThumb,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功');
									this.$router.push({
										path: '/home/commodity',
										query: {
											id: this.$route.query.id
										}
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							this.$message.error('请补全内容！');
							return false;
						}
					});
				} else {
					this.onUpdate(formName)
				}
			},
			onUpdate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this
						obj.$http({
							method: 'post',
							url: 'api/v2/goods/update',
							data: {
								cid: this.$route.query.id,
								id: this.form.id,
								// oneCate: this.form.one,
								// twoCate: this.form.two,
								// threeCate	: this.form.three,
								goodsName: this.form.name,
								status: this.form.resource,
								goodsParamList: this.form.inputList,
								roof: this.form.topping == true ? 0 : 1,
								content: this.form.detail,
								brief: this.form.desc,
								images: this.form.showPic,
								imagesThumb: this.form.showPicThumb,
								album: this.form.pic,
								albumThumb: this.form.picThumb,
							},
						}).then((res) => {
							if (res.data.status == 200) {
								this.$message.success('修改成功');
								this.$router.push({
									path: '/home/commodity',
									query: {
										id: this.$route.query.id
									}
								})
							} else {
								this.$message.error(res.data.message);
							}
						})
					} else {
						this.$message.error('请完善商品信息！')
						return false;
					}
				});
			},
			change(val) {
				console.log(val)

			},
			beforePic(file, fileList) {
				this.loading = true
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/goods/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						obj.$message.success(res.data.message)
						this.form.showPic = res.data.data.images
						this.form.showPicThumb = res.data.data.imagesThumb
						this.fileList = []
						this.fileList.push({
							url: this.settings.apiBaseImg + res.data.data.imagesThumb
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//素材库选择图片
			selectPic(index, rows) {
				if (this.picBook == 1) {
					this.form.pic = rows.path
					this.form.picThumb = rows.path
					this.albumList=[]
											this.albumList.push({url:this.settings.apiBaseImg +  rows.path})
					this.dialogVisible = false
				} else {
					console.log(rows.path)
					this.form.showPic = rows.path
					this.form.showPicThumb = rows.path
					this.dialogVisible = false
					this.fileList=[]
											this.fileList.push({url:this.settings.apiBaseImg +  rows.path})
				}

			},
			beforePics(file, fileList) {
				this.loading = true
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/goods/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						obj.$message.success(res.data.message)
						this.form.pic = res.data.data.images
						this.form.picThumb = res.data.data.imagesThumb
						this.albumList = []
						this.albumList.push({
							url: this.settings.apiBaseImg + res.data.data.imagesThumb
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			getUrl(file, fileList) {
				this.form.showPic = fileList.name
			},
			handlePic(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			removeUrl() {
				this.form.pic = ''
			},
			getAlbum() {
				console.log(this.albumList)
			}
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-input__inner {
		height: 30px !important;
	}

	/deep/ .el-form-item__label {

		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 40px;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.3;
	}

	.title {
		display: inline-block;
		padding: 10px 0 30px 0;
	}

	.titleTip {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/commodity/productUpdate.vue